import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { AuthGuard } from 'modules/shared/guards/auth.guards';
import { EnforcedMFAGuard } from 'modules/shared/guards/enforced-mfa.guard';
import { LoggedGuard } from 'modules/shared/guards/logged.guard';

import { LoginComponent } from './pages/login/login.component';
import { ForgotPasswordComponent } from './pages/forgot-password/forgot-password.component';
import { SelectDomainComponent } from './pages/select-domain/select-domain.component';
import { NotFoundComponent } from './pages/not-found/not-found.component';
import { SetupMultiFactorPage } from './pages/setup-multi-factor/setup-multi-factor.page';

const routes: Routes = [
  {
    path: 'login',
    component: LoginComponent,
    canActivate: [LoggedGuard]
  }, {
    path: 'forgot-password',
    component: ForgotPasswordComponent
  }, {
    path: 'mfa',
    canActivate: [AuthGuard],
    children: [
      {
        path: 'setup',
        component: SetupMultiFactorPage
      }
    ]
  }, {
    path: 'select-domain',
    component: SelectDomainComponent,
    canActivate: [AuthGuard, EnforcedMFAGuard]
  }, {
    path: 'page-not-found',
    component: NotFoundComponent
  }, {
    path: '**',
    redirectTo: 'page-not-found'
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class CoreRoutingModule { }
